import { i18n } from "@/i18n";
import { ClearAllCacheFromIndexedDB } from "@/IndexedDB/cacheIndexedDB";
import store from "@/store/index";
import { Route } from "vue-router";
import { CreateMetaTagName, RemoveMetaTagName } from "./shareHelper";
export function AuthorizeModels(routerName?: string | null) {
  if (
    routerName !== "logout" &&
    routerName !== null &&
    routerName !== "sessionExpire" &&
    routerName !== "canNotAccessMerchant" &&
    routerName !== "statement" &&
    routerName !== "register" &&
    routerName !== "acceptInvitation" &&
    routerName !== "forgotPwd" &&
    routerName !== "resetPwd" &&
    routerName !== "resetPwd"
  ) {
    if (routerName == "login") {
      store.dispatch("LogIn/DoGetRefreshTokenExpiration", { root: true });
    } else {
      store.dispatch("LogIn/AuthorizeModels", { root: true });
    }
  }
}
export function SetSessionEMIFromURL(emi: any) {
  let getSession: any = sessionStorage.getItem("userMerchant");
  getSession = JSON.parse(getSession);
  if (!getSession) {
    getSession = {
      eui: "",
      emi: emi,
    };
  } else {
    getSession.emi = emi ? emi : "";
  }
  sessionStorage.setItem("userMerchant", JSON.stringify(getSession));
}
export function SetLastUrl(to: Route) {
  if (
    to.name !== "sessionExpire" &&
    to.name !== "canNotAccessMerchant" &&
    to.name !== "logout" &&
    to.name !== "login" &&
    to.name !== "register" &&
    to.name !== "welcome" &&
    to.name !== "pageNotFound" &&
    to.name !== "update" &&
    to.name !== "acceptInvitation" &&
    to.name !== "forgotPwd" &&
    to.name !== "resetPwd"
  ) {
    const query: any = Object.assign({}, to.query);

    let queryStr = "";
    for (const [key, value] of Object.entries(query)) {
      if (value) {
        queryStr += `${key}=${value}&`;
      }
    }

    localStorage.setItem("lastUrlPeakTax", `${window.location.origin}${to.path}${queryStr ? "?" + queryStr : ""}`);
  }
}
export function ClearLastUrl() {
  localStorage.removeItem("lastUrlPeakTax");
}

const SetMetaTagRobots = (to: Route) => {
  RemoveMetaTagName("robots");
  if (to.meta?.noindex !== false) {
    CreateMetaTagName("robots", "noindex");
  }
};

const SetMetaTagDescription = (to: Route) => {
  RemoveMetaTagName("description");
  if (to.meta?.description) {
    CreateMetaTagName("description", i18n.t(to.meta.description).toString());
  }
};

export const SetMetaTagFromRouter = (to: Route) => {
  SetMetaTagRobots(to);
  SetMetaTagDescription(to);
};

export const CheckAssetTokenValid = async (): Promise<void> => {
  const isAssetTokenValid: boolean = await store.dispatch("LogIn/DoIntrospectAccessToken");
  if (!isAssetTokenValid) {
    await ClearAllCacheFromIndexedDB();
  }
};

export const CheckAssetTokenValidBeforeRouterChange = async (fromRouter: Route): Promise<void> => {
  if (!fromRouter.name) {
    await CheckAssetTokenValid();
  }
};
